const getTransferRecordScopes = [
  'TRANSFER_RECORDS_REMOVED',
];
const chains = [];
chains.push({ _operation: 'createTransferRecord', api: '/transfer-record', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'getTransferRecords', api: '/transfer-records', defaultData: [], httpVerb: 'get', scopes: getTransferRecordScopes });
chains.push({ _operation: 'removeTransferRecordById', api: '/transfer-record/:objectId/remove', defaultData: null, httpVerb: 'put' });
chains.push({ _operation: 'updateTransferRecordById', api: '/transfer-record/:objectId', defaultData: null, httpVerb: 'patch' });
export default chains;
